<style scoped lang="scss">
.development-content-div {
    margin-bottom: 5rem !important;
    background-color: rgb(242 242 242) !important;
    font-size: 1rem;
    min-height: 100vh;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.not-developer-div {
    padding: 1rem;
    width: fit-content;
    background-color: white;
    border-radius: 5px;
}


.deveploer-content {
    padding: 1rem;
    margin-left: 2rem;
    margin-top: 2rem;
    background-color: white;
}

.includes_table {
    width: fit-content;
}

.price_table td,
.price_table th,
.agentPrice_table td,
.agentPrice_table th {
    padding: 1rem;
    font-size: 1rem;
    text-align: center;
}

@media screen and (min-width: 768px) {
    .data-table {
        max-width: 70vw;
    }

    .el-select-liu,
    .el-input {
        width: 10rem;
    }

    .el-textarea {
        width: 20vw;
    }

    .el-dialog {
        width: fit-content !important;
    }

}

.el-dialog {
    width: fit-content !important;
}

@media screen and (max-width: 769px) {
    .data-table {
        width: fit-content;
    }

    .el-select-liu,
    .el-input {
        width: 50vw;
    }

    .el-textarea {
        width: 65vw;
    }

    .el-dialog-liu {
        max-width: 80vw;
    }
}

.pagination-div {
    width: fit-content;
    float: right;
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;padding-left: 0;background-color: rgb(242, 242, 242) !important;overflow: auto;height:100vh;">
                    <div class="development-content-div">
                        <div v-if="isDeveloper == 0" class="not-developer-praent">
                            <div class="not-developer-div">
                                <p style="font-size: 1rem;">您还不是开发者，暂时无法查看本页面喔~</p>
                                <div
                                    style="text-align: center; width: fit-content;margin: 3rem auto 0.5rem;font-size: 1rem;">
                                    <el-button type="primary" @click="goApiUrl">
                                        成为开发者
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="isDeveloper == 1" class="d-flex flex-column deveploer-content rounded shadow">
                            <div>
                                <div>
                                    <span style="margin-left: 1rem;margin-right: 1rem;color:#616161">请选择插件</span>
                                    <el-select class="el-select-liu" v-model="selectIncludesId" placeholder="请选择"
                                        @change="getNoticeByIncludes">
                                        <el-option label="全部" :value="-1"></el-option>
                                        <el-option v-for="item in includes_data" :key="item.id"
                                            :label="item.id + '---' + item.name" :value="item.id"></el-option>
                                    </el-select>
                                    <el-button type="warning" style="margin-left: 1rem;"
                                        @click="noticeRelease.isShow = true">公告发布</el-button>
                                </div>
                                <el-table :data="noticeList" class="versionLog_table">

                                    <el-table-column prop="id" label="公告id" width="70" />
                                    <el-table-column prop="title" label="标题" width="200">
                                        <template v-slot="scope">
                                            <el-input style="width: fit-content;" autosize type="textarea"
                                                v-model="scope.row.title"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="content" label="内容" align="center">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.content" autosize type="textarea"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="create_date" label="发布时间" width="200" />
                                    <el-table-column prop="pluginId" label="插件ID" width="70" />
                                    <el-table-column label="操作" align="center">
                                        <template v-slot="scope">
                                            <el-button type="primary" @click="saveNotice(scope.row)">保存</el-button>
                                            <el-button type="primary" @click="deleteNotice(scope.row.id)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="pagination-div">
                                    <el-pagination class=" mt-4" background layout="prev, pager, next"
                                        :page-size="noticePage.pageSize" :total="noticePage.total"
                                        @current-change="currentChange" />
                                </div>
                            </div>

                        </div>
                        <el-dialog align-center v-model="noticeRelease.isShow" title="公告发布" width="450"
                            class="el-dialog-liu">
                            <el-form>
                                <el-form-item label="插件" :label-width="formLabelWidth">
                                    <el-select class="el-select-liu" v-model="noticeRelease.data.pluginId"
                                        placeholder="请选择">
                                        <el-option v-for="item in includes_data" :key="item.id"
                                            :label="item.id + '---' + item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="标题" :label-width="formLabelWidth">
                                    <el-input type="textarea" :rows="1" :autosize="{ minRows: 1, maxRows: 1 }"
                                        v-model="noticeRelease.data.title" autocomplete="off" />
                                </el-form-item>
                                <el-form-item label="内容" :rows="3" :label-width="formLabelWidth">
                                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="noticeRelease.data.content"
                                        autocomplete="off" />
                                </el-form-item>
                            </el-form>
                            <template #footer>
                                <div class="dialog-footer">
                                    <el-button @click="noticeRelease.isShow = false">关闭</el-button>
                                    <el-button type="primary" @click="addNotice">
                                        新增
                                    </el-button>
                                </div>
                            </template>
                        </el-dialog>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox, getIncludesList } from "@/utils/publicMethods"
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { data } from 'jquery';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            noticeList: [],
            noticePage: {
                currentPage: 1,
                pageSize: 5,
                total: 0
            },
            noticeRelease: {
                isShow: false,
                data: {
                    pluginId: -1,
                    title: "",
                    content: ""
                }
            },
            includes_data: [],
            selectIncludesId: -1
        }
    },
    methods: {
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        isNull(text) {
            return isNull(text);
        },
        currentChange(val) {
            this.noticePage.currentPage = val;
            this.getNoticeByIncludes();
        },
        getNoticeByIncludes() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/notice/list', {
                currentPage: this.noticePage.currentPage,
                pageSize: this.noticePage.pageSize,
                pluginId: this.selectIncludesId

            }, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.noticeList = res.data.data.list;
                        this.noticePage.total = res.data.data.total;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveNotice(row) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/notice/save', JSON.stringify(row), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        ElMessage.success(res.data.msg)
                        setTimeout(() => {
                            this.getNoticeByIncludes();
                        }, 1000)
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error("失败")
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error("错误：" + err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getIncludes() {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludes', { timeout: 5000, headers }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }, err => {
                    ElMessage.error(err)
                }
            )
        },
        deleteNotice(id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/notice/del?id=' + id, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        ElMessage.success(res.data.msg);
                        this.getNoticeByIncludes();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addNotice() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/notice/add', JSON.stringify(this.noticeRelease.data), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        ElMessage.success(res.data.msg);
                        this.noticeRelease.isShow = false;
                        this.getNoticeByIncludes();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        }
    },
    mounted() {
        this.getNoticeByIncludes()
        this.getIncludes()
    }
})
</script>
